import postGridIntelView from './postGridIntelComponent.html';
import './postGridIntelComponent.css';
import { AssetManager } from 'components/sharpr/assetManager/AssetManager.js';
import VideoPlayer from 'components/sharpr/videoPlayer/VideoPlayer.js';
import moment from 'moment';
import { PostTypes } from '../../postType/PostTypesEnum.js';

export function postGridIntelComponent() {
	return {
		bindings: {
			post: '=',
			geometry: '<',
			showPostActions: '<?',
			showPostCredit: '<?',
		},
		controllerAs: 'vm',
		controller: postGridIntelComponentCtrl,
		template: postGridIntelView,
	};
}

export class postGridIntelComponentCtrl {
	constructor($element, $timeout, $scope, ImageSizer, Api, Att, EventTracker, FineTunePosts, modal, Post, Theme) {
		'ngInject';
		this.Api = Api;
		this.Att = Att;
		this.EventTracker = EventTracker;
		this.FineTunePosts = FineTunePosts;
		this.ImageSizer = ImageSizer;
		this.modal = modal;
		this.Post = Post;
		this.Theme = Theme;
		$scope.$watchGroup(
			['vm.geometry', 'vm.post.image.url', 'vm.post.image.width', 'vm.post.image.height'],
			(newVal, oldVal) => {
				if (newVal != oldVal) {
					this.setup();
				}
			}
		);
		this.$timeout = $timeout;
		this.$element = $element;
		this.setup();
	}

	setup() {
		// default to true
		this.showPostActions = this.showPostActions === false ? false : true;
		this.showPostCredit = this.showPostCredit === false ? false : true;
		this.imageWidth = 0;
		this.imageHeight = 0;
		if (this.post && this.post.image) {
			this.setupImage();
		}
	}

	setupImage() {
		var displaySize = this.ImageSizer.getSize(this.post.image, this.geometry);
		this.imageWidth = displaySize[0];
		this.imageHeight = displaySize[1];
		this.$element.css('width', this.imageWidth + 'px');
	}

	$onInit() {
		AssetManager.loadBubbleCss(this.post);
		if (this.post && this.post.highlights && this.post.highlights.length) {
			this.highlights = '<p>' + this.post.highlights.join('</p><p>') + '</p>';
		}
	}

	addInsight() {
		const options = {
			heading: 'Enter your insight',
			text: this.post.headline,
		};
		this.modal.prompt(options).then(
			intel_text => {
				this.post.intel_text = intel_text;
				if (this.post.id > 0) {
					// post id is negative if file is uploading
					this.Api.patch(`/posts/${this.post.id}`, { intel_text });
				}
			},
			() => {}
		);
	}

	viewFullscreen() {
		if (this.post.is_story) {
			// go to story page, not in modal
			return;
		}
		this.Post.viewFullscreen(this.post);
	}

	markAsViewed() {
		const source = document.title.replace(' :: Sharpr', '');
		this.EventTracker.save('post_view', {
			post_id: this.post.id,
			source,
		});
	}

	isArticle() {
		return !this.isVideo() && !this.isSlideshow();
	}

	isVideo() {
		return !!VideoPlayer.getPlayableUrl(this.post);
	}

	isSlideshow() {
		return this.post.attachment_thumbnails && this.post.attachment_thumbnails.length > 1;
	}

	isPreviewable() {
		return this.post.attachment_icon_classes && this.post.attachment_icon_classes.length > 0;
	}

	isShortPost() {
		let url = '';
		try {
			url = this.post.image.url;
		} catch (e) {
			return false;
		}

		if (!url) {
			return false;
		}

		const minHeight = 190;
		var height = parseInt(this.imageHeight);
		if (!this.post.intel_text) {
			height -= 80;
		}
		return height < minHeight;
	}

	cancelFileUpload() {
		this.post.deleted_at = moment().format();
		this.post.file.cancel();
	}

	deleteErroredPost() {
		// sometimes we delete posts that aren't yet created in the db,
		// so we just need to make sure it doesn't show in the UI
		this.post.deleted_at = moment().format();
		if (this.post.id > -1) {
			this.Api.delete(`/posts/${this.post.id}`);
		}
	}
}
